/**
 * The Plus-incompatibility annotation, per cause: the modifier cluster renders unremapped and this
 * note says why (never a silent mis-render). "no-neighbor" = the board has no key beside this
 * hand's Control to host the relocated Shift; "board-layer" = the active mapping is a board layer,
 * which carries its own fixed codes and has no character map for the remap to ride. Shown by the
 * single-board canvas and by each compare column, per side.
 */
export function PlusNote({ reason }: { reason: "no-neighbor" | "board-layer" }) {
  return (
    <div className="plus-note" role="note">
      {reason === "board-layer"
        ? "TheCore Plus relocates the modifier cluster through a universal layout's character " +
          "map, so it cannot apply to a board layer. The selected board layer is shown with its " +
          "own mapping, without the Plus relocation."
        : "TheCore Plus relocates Shift onto the key beside this hand's Control, which this " +
          "keyboard lacks, so the modifier cluster is shown unremapped. Pick a board with a Menu " +
          "or Win key beside Control to see the Plus layout."}
    </div>
  );
}
